import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "35.88",
      height: "2.64",
      x: ".121",
      y: "10.52",
      rx: "1.32"
    }, null, -1),
    _createElementVNode("rect", {
      width: "35.88",
      height: "2.64",
      x: ".121",
      y: ".84",
      rx: "1.32"
    }, null, -1)
  ]))]))
}
export default { render: render }